import soloSlice from "./solo.slice";

export * from "./solo.slice";
export * from "./solo.saga";

export default soloSlice.reducer;
